<template>
  <v-chart
    class="v-chart"
    :options="options"
    :init-options="{}"
    autoresize />
</template>

<script>
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
export default {
  name: 'ProductChart',
  components: {
    'v-chart': ECharts
  },
  props: {
    series: {
      type: Object,
      default() {
        return {
          xAxis: [],
          s1: [],
          s2: [],
          s3: []
        }
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    options({ series }) {
      return {
        tooltip: {
          trigger: 'axis',
          // formatter: '{a0}: {c0}<br />{a1}: {c1}'
          formatter: function(params) {
            let result = params[0].axisValue + '</br>'
            params.forEach(function(item) {
              result += item.marker + item.seriesName + '：' + item.data + (item.seriesIndex === 2 ? '件' : '元') + '</br>'
            })
            return result
          }
        },
        legend: {
          data: ['平均货单价', '销售金额', '商品数']
        },
        xAxis: [
          {
            type: 'category',
            data: series.xAxis,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              rotate: 45
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value}元'
            }
          },
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value}件'
            }
          }
        ],
        series: [
          {
            name: '平均货单价',
            type: 'line',
            smooth: true,
            data: series.s1
          },
          {
            name: '销售金额',
            type: 'line',
            smooth: true,
            data: series.s2
          },
          {
            name: '产品数',
            type: 'bar',
            yAxisIndex: 1,
            data: series.s3
          }
        ]
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-chart {
    height 300px!important
}
</style>
